// removed by extract-text-webpack-plugin
module.exports = {"Tag":"Tag__Tag___3Pdr2","TagGreen":"Tag__TagGreen___3QIJP","TagRed":"Tag__TagRed___3G6lm","TagOrange":"Tag__TagOrange___3IwI8","TagBlue":"Tag__TagBlue___U8pIe","TagGrey":"Tag__TagGrey___37SYf"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Tag/Tag.less
// module id = 1468
// module chunks = 0 1